class Location {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("location", () => ({
                    // AlpineRender
                    params: {},
                    period: {},
                    locResult: {},

                    // Data
                    CITY_TYPE: 3,

                    loading: null,
                    SEARCH: 1,
                    GEOLOC: 2,
                    SUGGESTION: 3,

                    CURRENT: "0",
                    WEEK_END: "1",
                    NEXT_WEEK: "2",
                    MONTH: "3",
                    PERIOD: "4",
                    previousFilter: this.CURRENT,
                    filter: this.CURRENT,

                    previousMonth: null,
                    month: null,

                    periodStartMin: null,
                    periodEndMin: null,
                    periodStartMax: null,
                    periodEndMax: null,
                    previousPeriodStart: null,
                    previousPeriodEnd: null,
                    periodStart: null,
                    periodEnd: null,

                    types: [],
                    previousTypes: [],

                    controller: null,

                    selected: null,
                    query: "",
                    lastSearches: [],
                    listLoc: [],
                    distance: 50,
                    date: null,
                    currentPage: 0,

                    error: null,

                    async init() {
                        window.alpineRender(this);

                        // Recherche enregistré
                        this.lastSearches =
                            window.useLocalStorage?.get("lastSearch") ?? [];

                        this.resetForm();
                    },
                    resetForm() {
                        this.error = null;

                        // Distance
                        this.distance =
                            this.params.distance ??
                            window.useLocalStorage?.get("lastDistance") ??
                            50;

                        if (this.locResult && this.locResult.title) {
                            this.onSelectLocation(this.locResult);
                        } else if (
                            this.lastSearches &&
                            this.lastSearches[0] &&
                            this.lastSearches[0].title
                        ) {
                            this.onSelectLocation(this.lastSearches[0]);
                        }

                        this.listLoc = [];
                    },

                    // Geolocation
                    onGeolocation(element = null) {
                        if (element && element.ariaDisabled === "true") {
                            return;
                        }
                        this.openDialogSearch();
                        this.loading = this.GEOLOC;
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                window.useHttpGeo
                                    .get(
                                        "/api/loc/reverse",
                                        {
                                            lat: position.coords.latitude,
                                            lon: position.coords.longitude,
                                        },
                                        { extra: { dialog: true } },
                                    )
                                    .then(({ body }) => {
                                        setTimeout(() => {
                                            this.loading = null;
                                            this.error = null;
                                            this.onSelectLocation(
                                                this.locCardResult(body.result),
                                            );
                                        }, 250);
                                    })
                                    .catch((e) => {
                                        if (e.data.error !== "cancel") {
                                            setTimeout(() => {
                                                this.loading = null;
                                                this.onSelectLocation(null);
                                                this.error =
                                                    "Problème de géolocalisation";
                                            }, 250);
                                        }
                                    });
                            },
                            () => {
                                this.loading = null;
                                this.onSelectLocation(null);
                                this.error = "Problème de géolocalisation";
                            },
                            {
                                maximumAge: 5 * 60 * 1000, // Temps maximum du cache de la position (ms)
                                timeout: 10 * 1000, // Timeout de la recherche de position (ms)
                                enableHighAccuracy: true, // Mode haute précision (gourmand en ressources)
                            },
                        );
                    },

                    onSelectSuggestion(location) {
                        this.loading = this.SUGGESTION;
                        setTimeout(() => {
                            this.loading = null;
                            this.onSelectLocation(location);
                        }, 250);
                    },

                    // api de recherche de localisation - autocomplete- --------------------
                    onSearch() {
                        this.error = null;
                        if (this.controller) {
                            this.controller.abort("cancel");
                        }
                        this.selected = null;

                        if (!this.query.length) {
                            this.listLoc = [];
                            this.loading = null;
                            return;
                        }

                        this.controller = new AbortController();
                        this.loading = this.SEARCH;
                        window.useHttpApi
                            .get(
                                "/v1/locations",
                                { search: this.query },
                                {
                                    signal: this.controller.signal,
                                    extra: { dialog: true },
                                },
                            )
                            .then(({ body }) => {
                                this.listLoc = body;
                            })
                            .catch(() => {
                                this.listLoc = [];
                            })
                            .finally(() => {
                                this.loading = null;
                            });
                    },

                    // validation de la localisation et redirection --------------------
                    onSubmit(element) {
                        this.error = null;
                        if (element.ariaDisabled === "true") {
                            return;
                        }

                        useLocalStorage.set("navigations", []);

                        const alias = this.selected?.alias || this.params.loc;

                        const parts = ["/evenements"];
                        parts.push(alias);

                        switch (this.filter) {
                            case this.WEEK_END:
                                parts.push(this.period.WEEKENDS);
                                break;
                            case this.NEXT_WEEK:
                                parts.push(this.period.WEEKS);
                                break;
                            case this.MONTH:
                                parts.push(this.period.MONTHS[this.month]);
                                break;
                            default:
                                break;
                        }

                        const url = parts.join("/");
                        const redirect = new URL(url, location.origin);

                        if (
                            (this.selected &&
                                this.selected.type === this.CITY_TYPE) ||
                            this.locResult.type === this.CITY_TYPE
                        ) {
                            redirect.searchParams.append(
                                "distance",
                                this.distance,
                            );
                        }

                        if (
                            this.filter === this.PERIOD &&
                            this.periodStart &&
                            this.periodEnd
                        ) {
                            redirect.searchParams.append(
                                "min",
                                this.periodStart,
                            );
                            redirect.searchParams.append("max", this.periodEnd);
                        }

                        if (
                            this.previousTypes.length &&
                            this.previousTypes.length !== this.agendaTags.length
                        ) {
                            this.previousTypes.forEach((tag) => {
                                redirect.searchParams.append(`tags[]`, tag);
                            });
                        }

                        if (this.selected) {
                            const newLastSearch = [this.selected];
                            this.lastSearches.forEach((search) => {
                                if (
                                    search.alias !== this.selected?.alias &&
                                    newLastSearch.length < 5
                                ) {
                                    newLastSearch.push(search);
                                }
                            });

                            useLocalStorage.set("lastSearch", newLastSearch);

                            if (
                                this.lastSearches[0]?.alias !==
                                newLastSearch[0].alias
                            ) {
                                useLocalStorage.remove("suggestions");
                            }
                        }

                        useLocalStorage.set("lastDistance", this.distance);

                        window.location.href = redirect.href;

                        const dialogFilter = document.querySelector(
                            `[x-ref='dialogFilter']`,
                        );
                        if (dialogFilter?.open) {
                            dialogFilter.close();
                        }

                        const dialogSearch = document.querySelector(
                            `[x-ref='dialogSearch']`,
                        );
                        if (dialogSearch?.open) {
                            dialogSearch.close();
                        }
                    },

                    // Choix de la localisation --------------------
                    onSelectLocation(location) {
                        this.error = null;
                        if (!location) {
                            this.selected = null;
                            this.query = "";
                            return;
                        }

                        this.selected = location;
                        this.query = `${location.title} ${location.adminCode ? `(${location.adminCode})` : ""}`;

                        setTimeout(() => {
                            document
                                .querySelector(`[x-ref='inputSearch']`)
                                ?.focus();
                        }, 0);
                    },

                    // ------------------------------------------------------------------------------------------------------------------------------ //
                    // Copy of LocCardTrait.php  //
                    // ------------------------------------------------------------------------------------------------------------------------------ //

                    locCardResult(geo) {
                        const result = {
                            type: geo.type,
                            alias: geo.city.alias,
                            flag: geo.country.id,
                            title: geo.city.name,
                        };

                        if (geo.country.id === "MC") {
                            result.type = 1;
                            result.alias = geo.country.alias;
                            return result;
                        }

                        if (
                            !geo.admin ||
                            ["AD", "LU"].includes(geo.country.id)
                        ) {
                            result.subtitle = geo.country.name;
                            return result;
                        }

                        const adminCode = this.adminCode(geo.admin.id, false);
                        if (geo.admin.id === "FR-75") {
                            // TODO ALD API DOESN'T SEND PARENT
                            result.subtitle = `Île-de-France (${adminCode})`;
                            result.adminCode = adminCode;
                            return result;
                        }

                        result.subtitle = `${geo.admin.name} (${adminCode})`;
                        result.adminCode = adminCode;

                        return result;
                    },

                    adminCode(adminId, lowercase = true) {
                        let code = adminId.substring(3);

                        switch (code.toLowerCase()) {
                            case "gp":
                                code = "971";
                                break;
                            case "mq":
                                code = "972";
                                break;
                            case "gf":
                                code = "973";
                                break;
                            case "re":
                                code = "974";
                                break;
                            case "pm":
                                code = "975";
                                break;
                            case "yt":
                                code = "976";
                                break;
                            case "bl":
                                code = "977";
                                break;
                            case "mf":
                                code = "978";
                                break;
                            case "wf":
                                code = "986";
                                break;
                            case "pf":
                                code = "987";
                                break;
                        }

                        return lowercase
                            ? code.toLowerCase()
                            : code.toUpperCase();
                    },

                    searchLastSearch() {
                        if (this.lastSearches.length) {
                            const url = `/evenements/${this.lastSearches[0].alias}${this.lastSearches[0].type === 3 ? `?distance=${this.distance}` : ""}`;
                            const redirect = new URL(url, location.origin);
                            window.location.href = redirect.href;
                        } else {
                            // this.openDialogSearch();
                            window.useSnackbar.add({
                                key: window.useSnackbar.NOTICE,
                                message: "Veuillez choisir une localisation.",
                            });
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new Location();
